/* eslint-disable sort-keys-fix/sort-keys-fix */
import type { NativoAdPlacementType } from './entities';

export const nativoAdWrapperClassnames: Record<NativoAdPlacementType, string> = {
  'in-content': 'nativo-placement-in-content',
  'in-content-article-page': 'nativo-placement-in-content-ap',
  'standalone-home-page': 'nativo-placement-standalone-hp',
  'quote-news-feed-1': 'nativo-placement-quote-news-feed-1',
  sidebar: 'nativo-placement-homepage-sidebar',
};

export const nativoAdPlaceholderHeightMap: Record<NativoAdPlacementType, string> = {
  'in-content': 'min-h-[250px]',
  'in-content-article-page': '',
  'standalone-home-page': 'min-h-[250px]',
  'quote-news-feed-1': '',
  sidebar: 'min-h-[250px]',
};
